module.exports = __webpack_public_path__ + "img/mm.1d98dbb4.svg";